// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2l0k3","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__HIf5v"};